import { render, staticRenderFns } from "./OsCustomerOverview.vue?vue&type=template&id=cdfc43b2&scoped=true"
import script from "./OsCustomerOverview.vue?vue&type=script&lang=ts"
export * from "./OsCustomerOverview.vue?vue&type=script&lang=ts"
import style0 from "./OsCustomerOverview.vue?vue&type=style&index=0&id=cdfc43b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfc43b2",
  null
  
)

export default component.exports